import React from "react";
import { useNavigate } from "react-router-dom";

const Devops = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/devops-services");
    window.scrollTo(0, 0);
  };

  return (
    <div className=" p-6">
      
       <div className="text-center">
        <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Our Services
        </h3>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mt-2 p-2">
          Ayanshtech delivers unparalleled expertise and state-of-the-art
          real-time communication solutions, tailored to empower businesses,
          enhance efficiency, and drive growth in today’s dynamic and
          competitive market landscape.
        </p>
      </div>
      
      <div className="flex flex-col-reverse lg:flex-row items-center lg:space-x-16">
        {/* Text Section */}
        <div className="lg:w-1/2 lg:text-left p-4">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3">
            DevOps Automation & Consulting Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 leading-relaxed mb-3">
            If you want your product releases to move faster without stressing your team, our <a className="  relative   
  before:content-[''] before:absolute before:left-1/2 before:-bottom-1 
  before:h-[2px] before:w-0 before:bg-green-600 
  before:transition-all before:duration-300 
  hover:before:left-0 hover:before:w-full text-green-600 font-bold" href="https://ayanshtechnology.com/devops-services"> DevOps Automation & Consulting Services</a> can help. Instead of dealing with slow builds or repeated manual tasks, we set up a smooth workflow that keeps everything running automatically. Our DevOps specialists look at how your system currently works and create a practical, budget-friendly plan that actually fits your business.
From CI/CD setup to cloud management or tightening security—we take care of the heavy lifting so your infrastructure stays stable and ready to scale.
          </p>
          <button
            onClick={handleClick}
            className="bg-gradient-to-r from-blue-600 to-green-500 text-white px-6 py-3 rounded-full group hover:from-blue-900 hover:to-blue-600"
          >
            View More
          </button>
        </div>

        {/* Image Section */}
        <div className="flex justify-center lg:w-1/2 ">
          <img
            src="/assets/images/homeImages/devops.png"
            alt="DevOps"
            className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
          />
        </div>
      </div>
    </div>
  );
};

export default Devops;
